import * as angular from 'angular';
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

/* @ngInject */
function $ContractsFactory($bringozFactory: $bringozFactory,
                           ContractsAPI: BringozApi,
                           PricePlanBundle_DS: DataStoreConfig) {

  function $contracts(id: string) {
    return $bringozFactory(id, ContractsAPI, PricePlanBundle_DS);
  }

  return $contracts;
}

angular
  .module('bringoz.admin.contracts')
  .factory('$contracts', $ContractsFactory);
